module.exports = {
  methods:
    contactStatusClass: ->
      "contact-status-#{@contact.recipient_status}"

    contactItemStatusClasses: ->
      classes = ['btn-contact-status']

      if @anyNextRecipientStatuses()
        classes.push 'dropdown-toggle'
      else
        classes.push 'btn-contact-fake'

      classes.push @contactStatusClass()
      classes.join ' '

    contactStatusDropdownAvailable: ->
      if @anyNextRecipientStatuses()
        'dropdown'
      else
        false

    contactStageDropdownAvailable: ->
      if @anyNextStage()
        'dropdown'
      else
        false

    contactStatusIconClass: ->
      "contact-event-subicon #{@contact.recipient_status}-icon"

    contactStageClass: ->
      "contact-stage-#{@contact.stage}"

    contactItemStageClasses: ->
      classes = ['btn-contact-stage']

      if @anyNextStage()
        classes.push 'dropdown-toggle'
      else
        classes.push 'btn-contact-fake'

      classes.push @contactStageClass()
      classes.join ' '

    contactItemLastActionTakenStateIcon: ->
      return false if !@contact.recipient_last_flow_action_taken_state
      if @contact.recipient_last_flow_action_taken_state == 'none'
        "glyphicon glyphicon-time"
      else
        "contact-event-subicon #{@contact.recipient_last_flow_action_taken_state}-icon"

    anyNextRecipientStatuses: ->
      ! jQuery.isEmptyObject @contact.next_valid_recipient_statuses

    anyNextStage: ->
      @contact.next_valid_stages != {}
}



// WEBPACK FOOTER //
// ./src/helpers/contacts/styles.coffee